import React from 'react';
import { IconIDAustria } from './Icons';
import { Button } from './StyledComponents';
import Store from '../store/Store';

interface IDLoginProps {
    onLoginIdAustria: () => void;
}

const IDLogin: React.FC<IDLoginProps> = ({ onLoginIdAustria }) => (
    <div className="flex flex-col flex-1">
        <div className="w-full flex my-20 flex-shrink-0">
            <IconIDAustria />
        </div>
        <div className="flex flex-col mt-auto">
            <p className="mb-16">
                Diese sichere elektronische Anmeldung können Sie auch mit einer Signaturkarte, mit einem FIDO-Sicherheitsschlüssel oder dem EU-Login nutzen.
            </p>
            <Button data-pw='button-id-austria' primary onClick={onLoginIdAustria}>
                Anmeldung mit ID-Austria
            </Button>
        </div>
    </div>
);

export default IDLogin;
